import React from "react";
import { useNavigate } from "react-router-dom";
import PublicHeader from "../components/homepage/public/PublicHeader";
import PublicFooter from "../components/homepage/public/PublicFooter";

const styles = {
  page: {
    fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    background: "#fff",
    color: "#0f172a",
  },
  container: { maxWidth: "1100px", margin: "0 auto", padding: "0 20px" },
  hero: {
    padding: "54px 0",
    background: "radial-gradient(circle at top, #f2f4fa 0, #ffffff 62%)",
    borderBottom: "1px solid #e2e8f0",
  },
  heroTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "42px",
    lineHeight: 1.06,
    margin: 0,
    color: "#020617",
  },
  heroText: { marginTop: "14px", fontSize: "15px", color: "#475569", lineHeight: 1.9 },
  heroActions: { marginTop: "18px", display: "flex", gap: "10px", flexWrap: "wrap" },
  btn: {
    fontSize: "13px",
    padding: "10px 18px",
    borderRadius: "999px",
    border: "1px solid #d0d7e2",
    background: "#ffffff",
    cursor: "pointer",
    fontWeight: 700,
  },
  btnPrimary: {
    background: "linear-gradient(135deg, #1d4ed8, #0b1530)",
    color: "#fff",
    borderColor: "transparent",
    boxShadow: "0 10px 25px rgba(15,23,42,0.14)",
  },
  section: { padding: "70px 0" },
  sectionAlt: {
    padding: "70px 0",
    background: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
    borderBottom: "1px solid #e2e8f0",
  },
  h2: { fontFamily: "'Playfair Display', serif", fontSize: "28px", margin: "0 0 10px", color: "#020617" },
  p: { fontSize: "14px", color: "#64748b", lineHeight: 1.9, margin: 0 },
  valuesGrid: {
    marginTop: "22px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "16px",
  },
  valueCard: {
    borderRadius: "18px",
    border: "1px solid #e2e8f0",
    background: "#fff",
    padding: "20px",
    boxShadow: "0 16px 40px rgba(15,23,42,0.06)",
  },
  valueTitle: { fontWeight: 800, margin: 0, fontSize: "16px", color: "#0f172a" },
  valueText: { marginTop: "8px", fontSize: "13px", color: "#64748b", lineHeight: 1.7 },
};

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <PublicHeader />

      <section style={styles.hero}>
        <div style={styles.container}>
          <h1 style={styles.heroTitle}>About True Education</h1>
          <p style={styles.heroText}>
            We are a tutoring and test-prep center in Cumming, GA, focused on SAT, ACT, math, reading,
            and writing. Our approach is diagnostic-first and personalized so students build
            confidence and see real score gains.
          </p>
          <div style={styles.heroActions}>
            <button
              style={{ ...styles.btn, ...styles.btnPrimary }}
              onClick={() => navigate("/tutoring/sat")}
            >
              Explore SAT Tutoring
            </button>
            <button style={styles.btn} onClick={() => navigate("/admissions")}>
              Admissions
            </button>
          </div>
        </div>
      </section>

      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={styles.h2}>Our Mission</h2>
          <p style={styles.p}>
            True Education exists to give each student a clear path to their goals. We don’t do
            one-size-fits-all. We diagnose, plan, and teach in a way that matches how you learn—
            so your time here translates directly into better scores and stronger skills.
          </p>
        </div>
      </section>

      <section style={styles.sectionAlt}>
        <div style={styles.container}>
          <h2 style={styles.h2}>What We Stand For</h2>
          <div style={styles.valuesGrid}>
            <div style={styles.valueCard}>
              <h3 style={styles.valueTitle}>Diagnostic-first</h3>
              <p style={styles.valueText}>
                We identify gaps and strengths before building a plan, so every session counts.
              </p>
            </div>
            <div style={styles.valueCard}>
              <h3 style={styles.valueTitle}>Personalized plans</h3>
              <p style={styles.valueText}>
                Roadmaps are tailored to your timeline, target score, and weak areas.
              </p>
            </div>
            <div style={styles.valueCard}>
              <h3 style={styles.valueTitle}>Results-focused</h3>
              <p style={styles.valueText}>
                We track progress and adjust so students see measurable improvement.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={styles.h2}>Where We Are</h2>
          <p style={styles.p}>
            We serve families in Cumming and the greater Atlanta area. Visit us for a free
            consultation or get in touch to learn more.
          </p>
          <p style={styles.p}>
            <strong>580 Peachtree Pkwy #102, Cumming, GA 30041</strong><br />
            (470) 470-4715 · cumming@trueeducation.com
          </p>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
